import { z } from "zod";
import { CONVERSATION_LIST_CONTACT_STATES, CONVERSATION_LIST_SORTS, CONVERSATION_LIST_STATUSES, CONVERSATION_LIST_VIEWS, PLATFORM_TYPES, } from "./constants.js";
import { cursorQuerySchema } from "./pagination.js";
const CONVERSATION_LIST_SEARCH_MAX_LENGTH = 200;
function omitBlankSearch(value) {
    if (value == null) {
        return undefined;
    }
    if (typeof value !== "string") {
        return value;
    }
    const trimmed = value.trim();
    return trimmed.length === 0 ? undefined : trimmed;
}
/**
 * Older links used `view=OPEN|CLOSED`. Those map onto `status` when status is
 * absent or agrees. A conflicting explicit status is rejected.
 */
function migrateLegacyViewStatus(value) {
    if (value == null || typeof value !== "object" || Array.isArray(value)) {
        return value;
    }
    const record = value;
    const view = record.view;
    if (view !== "OPEN" && view !== "CLOSED") {
        return value;
    }
    const status = record.status;
    if (status != null && status !== "ALL" && status !== view) {
        return { ...record, view: "LEGACY_VIEW_STATUS_CONFLICT" };
    }
    return {
        ...record,
        view: "ALL",
        status: status == null || status === "ALL" ? view : status,
    };
}
/**
 * Query string for GET /organizations/:organizationId/conversations.
 * HTTP query values are strings; `unread=true` is the only accepted unread form.
 * `view` and `status` are independent. View is ALL | MINE | UNASSIGNED.
 */
export const conversationListQuerySchema = z.preprocess(migrateLegacyViewStatus, cursorQuerySchema.extend({
    search: z.preprocess(omitBlankSearch, z.string().min(1).max(CONVERSATION_LIST_SEARCH_MAX_LENGTH).optional()),
    platform: z.enum(PLATFORM_TYPES).optional(),
    unread: z.literal("true").optional(),
    contactState: z.enum(CONVERSATION_LIST_CONTACT_STATES).optional(),
    sort: z.enum(CONVERSATION_LIST_SORTS).optional(),
    /** Assignment view. Omitted / ALL keeps every assignee. */
    view: z.enum(CONVERSATION_LIST_VIEWS).optional(),
    /** Open/Closed filter. Omitted / ALL keeps every status. Combines with view. */
    status: z.enum(CONVERSATION_LIST_STATUSES).optional(),
}));
export const CONVERSATION_LIST_SEARCH_MAX = CONVERSATION_LIST_SEARCH_MAX_LENGTH;
//# sourceMappingURL=conversation-list-query.js.map